var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 10C0.25 4.61522 4.61522 0.25 10 0.25C15.3848 0.25 19.75 4.61522 19.75 10C19.75 15.3848 15.3848 19.75 10 19.75C4.61522 19.75 0.25 15.3848 0.25 10ZM8.95624 8.55845C10.1025 7.98533 11.3931 9.02063 11.0823 10.2639L10.3733 13.0999L10.4148 13.0792C10.7852 12.894 11.2357 13.0441 11.421 13.4146C11.6062 13.7851 11.4561 14.2356 11.0856 14.4208L11.0441 14.4416C9.89785 15.0147 8.60723 13.9794 8.91805 12.7361L9.62706 9.90009L9.58557 9.92083C9.21509 10.1061 8.76459 9.95591 8.57934 9.58542C8.3941 9.21494 8.54427 8.76444 8.91475 8.57919L8.95624 8.55845ZM10 7C10.4142 7 10.75 6.66421 10.75 6.25C10.75 5.83579 10.4142 5.5 10 5.5C9.58579 5.5 9.25 5.83579 9.25 6.25C9.25 6.66421 9.58579 7 10 7Z",
    fill: "#00B1B2",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.809d89aaae503056bd05cf4f8fe8ff92.svg";
export { ForwardRef as ReactComponent };